<i *ngIf="icon && icon !== 'noIcon'" [class]="'pi ' + icon + (class ? (' ' + class) : '')"></i>
